import { render } from "./ForwardtoEmail.vue?vue&type=template&id=68f75cb2"
import script from "./ForwardtoEmail.vue?vue&type=script&lang=js"
export * from "./ForwardtoEmail.vue?vue&type=script&lang=js"

import "./ForwardtoEmail.vue?vue&type=style&index=0&id=68f75cb2&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__